import { createContext, useContext } from 'react'

export const JobMaskingContext = createContext(false)
export const useJobMasking = () => useContext(JobMaskingContext)

export const isVisibleJobField = (key, mode) =>
  /date/i.test(String(key)) ||
  (mode !== 'datesOnly' &&
    (/status/i.test(String(key)) ||
      ['jobId', 'job_Id', 'job_RecoveryJobId', 'recoveryJobId'].includes(key)))

export const maskJobField = (masked, key, value) =>
  masked && !isVisibleJobField(key, masked) ? 'XXXX' : value

export const maskDetailColumns = (columns, mode) =>
  columns.map(column => {
    if (column.children)
      return { ...column, children: maskDetailColumns(column.children, mode) }
    if (column.key === 'label') return column
    const field = column.key || column.dataIndex
    if (isVisibleJobField(field, mode)) return column
    return {
      ...column,
      render: (value, record, index) => {
        const visible =
          column.key === 'value' &&
          (isVisibleJobField(record?.key, mode) ||
            isVisibleJobField(record?.label, mode) ||
            record?.inputType === 'dateTimePicker')
        if (!visible) return 'XXXX'
        return column.render ? column.render(value, record, index) : value
      },
    }
  })
